import {
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { useState } from "react";
import { auth } from "../../firebaseConfig";
import { useNavigate } from "react-router-dom";
import SecondaryButton from "../../components/Buttons/SecondaryButton";

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<any>(null);
  const navigate = useNavigate(); // Initialize useNavigate

  const handleSignIn = async (event: any) => {
    event.preventDefault();
    setError(null); // Reset errors
    try {
      // Sign in with Firebase
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/");
      // Redirect to dashboard or other page as needed
    } catch (error: any) {
      console.log(error.message);

      setError("Wrong email or password.");
    }
  };

  const handlePasswordReset = async () => {
    if (!email) {
      setError("Please enter your email address to reset your password.");
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      alert("Password reset email sent!");
    } catch (error) {
      setError("Failed to send password reset email.");
    }
  };

  const navigateToSignUp = () => {
    navigate("/signup"); // Navigate to the Sign Up page
  };

  return (
    <div className="container mx-auto mt-4 p-4 flex flex-row items-center justify-center">
      <div className="w-1/2 bg-backgroundSecondary rounded-lg shadow-lg p-6">
        <h2 className="text-xl  font-bold mb-4">Sign In</h2>
        {error && <p className="text-red-500">{error}</p>}
        <form onSubmit={handleSignIn}>
          <div className="mb-4">
            <label className="block text-sm font-bold mb-2" htmlFor="email">
              Email
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="email"
              type="email"
              placeholder="Email"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="mb-6">
            <label className="block text-sm font-bold mb-2" htmlFor="password">
              Password
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
              id="password"
              type="password"
              placeholder="******************"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <p className=" mb-4">
            Forgot your password?{" "}
            <span
              className="font-semibold cursor-pointer"
              onClick={handlePasswordReset}
            >
              Reset Password
            </span>
          </p>
          <div className="mb-4">
            <button
              className="bg-primary hover:bg-primaryHover font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full text-white"
              type="submit"
            >
              Sign In
            </button>
          </div>
        </form>
      </div>
      <div className="w-1/2 p-4">
        <div className="text-center mt-4">
          <p className=" mb-4">
            No account yet?{" "}
            <span className="font-semibold">Sign up for free</span>
          </p>
          <SecondaryButton onClick={navigateToSignUp}>Sign Up</SecondaryButton>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
